import { gsap } from 'gsap';

const initMenu = (element) => {
    const body = document.querySelector('.js-body');
    const menuToggle = element.querySelectorAll('.js-menu-button');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'is-active';
    let isActive = false;

    const menuItems = element.querySelectorAll('.menu-item');

    menuToggle.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            isActive = !isActive;

            if (isActive) {
                menuToggle[0].textContent = 'Close';
                gsap.set(menuItems, { autoAlpha: 0, xPercent: -10 });
                body.classList.add(stopScrollingClass, isActiveClass);
                gsap.to(menuItems, {
                    autoAlpha: 1,
                    xPercent: 0,
                    duration: .375,
                    ease: 'power3.inOut',
                    stagger: .15,
                });

            } else {
                menuToggle[0].textContent = 'Menu';
                body.classList.remove(stopScrollingClass, isActiveClass);
            }
        });
    });
};

export { initMenu as default };
